/**
 * Header JavaScript - Cinemasterpieces
 * Handles cart counter updates and header interactions
 */

class HeaderManager {
  constructor() {
    this.init();
  }

  init() {
    this.setupCartListeners();
    this.setupOffcanvasListeners();
  }

  /**
   * Listen for cart updates and refresh the cart count badge
   */
  setupCartListeners() {
    document.addEventListener('cart:updated', (event) => {
      this.updateCartCount(event.detail?.cart?.item_count);
    });

    // Listen for Shopify Section Rendering API updates
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId.includes('cart-count-badge')) {
        this.refreshCartBadge();
      }
    });
  }

  /**
   * Update cart count badges
   */
  updateCartCount(count) {
    const badges = document.querySelectorAll('.cart-count-badge');
    badges.forEach(badge => {
      badge.textContent = count || 0;
      badge.setAttribute('data-count', count || 0);
    });

    // Update aria-labels for accessibility
    const cartButtons = document.querySelectorAll('[aria-label*="cart"]');
    cartButtons.forEach(button => {
      const label = button.getAttribute('aria-label');
      if (label) {
        // Update the count in the aria-label
        button.setAttribute('aria-label', label.replace(/\d+/, count || 0));
      }
    });
  }

  /**
   * Refresh cart badge from Shopify's section rendering
   */
  async refreshCartBadge() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}?section_id=cart-count-badge`);
      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newBadge = doc.querySelector('.cart-count-badge');

        if (newBadge) {
          const count = newBadge.getAttribute('data-count');
          this.updateCartCount(count);
        }
      }
    } catch (error) {
      console.error('Error refreshing cart badge:', error);
    }
  }

  /**
   * Setup offcanvas menu interactions
   */
  setupOffcanvasListeners() {
    const offcanvasMenu = document.getElementById('offcanvas-menu');
    if (!offcanvasMenu) return;

    // Close offcanvas when clicking on a link (mobile)
    offcanvasMenu.addEventListener('click', (event) => {
      if (event.target.matches('a:not([data-bs-toggle])')) {
        const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasMenu);
        if (bsOffcanvas) {
          bsOffcanvas.hide();
        }
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeaderManager();
  });
} else {
  new HeaderManager();
}

// Export for external use
window.HeaderManager = HeaderManager;
